import React, { useState } from "react";
import { Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartDynamicColor";
import { OverviewChartOptions } from "./type";

const Overview = ({ dataColors }: any) => {
  const overViewChartColors = getChartColorsArray(dataColors);
  const series = [
    {
      name: "BTC",
      data: [[]],
    },
  ];

  const [options, setOptions] = useState<OverviewChartOptions>({
    chart: { toolbar: "false" },
    dataLabels: { enabled: !1 },
    stroke: { curve: "smooth", width: 2 },
    markers: { size: 0, style: "hollow" },
    xaxis: {
      type: "datetime",
      min: new Date("01 Mar 2012").getTime(),
      tickAmount: 6,
    },
    tooltip: { x: { format: "dd MMM yyyy" } },
    colors: overViewChartColors,
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.6,
        opacityTo: 0.05,
        stops: [42, 100, 100, 100],
      },
    },
  }) as any[];

  const [activeM, setActiveM] = useState<boolean>(false);
  const [active6M, setActive6M] = useState<boolean>(false);
  const [activeY, setActiveY] = useState<boolean>(true);
  const [activeA, setActiveA] = useState<boolean>(false);

  const updateChartMonthly = () => {
    var newxaxis = {
      min: new Date("28 Jan 2013").getTime(),
      max: new Date("27 Feb 2013").getTime(),
    };
    const modifiedOptions: any = {
      ...options,
      xaxis: newxaxis,
    };
    setOptions(modifiedOptions);
    setActiveM(true);
    setActive6M(false);
    setActiveY(false);
    setActiveA(false);
  };

  const updateChartSixMonth = () => {
    var newxaxis = {
      min: new Date("27 Sep 2012").getTime(),
      max: new Date("27 Feb 2013").getTime(),
    };
    const modifiedOptions: any = {
      ...options,
      xaxis: newxaxis,
    };
    setOptions(modifiedOptions);
    setActiveM(false);
    setActive6M(true);
    setActiveY(false);
    setActiveA(false);
  };

  const updateChartYearly = () => {
    var newxaxis = {
      min: new Date("27 Feb 2012").getTime(),
      max: new Date("27 Feb 2013").getTime(),
    };
    const modifiedOptions: any = {
      ...options,
      xaxis: newxaxis,
    };
    setOptions(modifiedOptions);
    setActiveM(false);
    setActive6M(false);
    setActiveY(true);
    setActiveA(false);
  };

  const updateChartAll = () => {
    var newxaxis = { min: void 0, max: void 0 };
    const modifiedOptions: any = {
      ...options,
      xaxis: newxaxis,
    };
    setOptions(modifiedOptions);

    setActiveM(false);
    setActive6M(false);
    setActiveY(false);
    setActiveA(true);
  };

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardBody>
            <CardTitle tag="h4" className="mb-3">
              Overview
            </CardTitle>
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
                <div className="toolbar d-flex flex-wrap gap-2 justify-content-center">
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={activeM ? "active" : ""}
                    onClick={() => updateChartMonthly()}
                    id="one_month"
                  >
                    1M
                  </Button>
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={active6M ? "active" : ""}
                    onClick={() => updateChartSixMonth()}
                    id="six_months"
                  >
                    6M
                  </Button>
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={activeY ? "active" : ""}
                    onClick={() => updateChartYearly()}
                    id="one_year"
                  >
                    1Y
                  </Button>
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={activeA ? "active" : ""}
                    onClick={() => updateChartAll()}
                    id="all"
                  >
                    ALL
                  </Button>
                </div>
                <div id="overview-chart-timeline">
                  <ReactApexChart
                    options={options}
                    series={series}
                    type="area"
                    height={240}
                  />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Overview;
